"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M1.41 1.69 0 3.1l2 2V21h15.9l3 3 1.41-1.41zM6 19H4v-2h2zm0-4H4v-2h2zm-2-4V9h2v2zm6 8H8v-2h2zm-2-4v-2h2v2zm4 4v-2h1.9l2 2zM8 5h2v2h-.45L12 9.45V9h8v8.45l2 2V7H12V3H5.55L8 5.45zm8 6h2v2h-2z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M12 9v.45l8 8V9zm6 4h-2v-2h2z",
  opacity: ".3"
}, "1")], 'DomainDisabledTwoTone');